import { render, staticRenderFns } from "./CostAdditions.vue?vue&type=template&id=0cca0b41&scoped=true"
import script from "./CostAdditions.vue?vue&type=script&lang=js"
export * from "./CostAdditions.vue?vue&type=script&lang=js"
import style0 from "./CostAdditions.vue?vue&type=style&index=0&id=0cca0b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca0b41",
  null
  
)

export default component.exports